import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

// This is the same helper as {{get}} but this allows the propertyName to have a
// period (.) in it. The {{get}} helper treats a period as a child object.
export default helper(function ([object, propertyName]: any): any {
  assert('propertyName must be a string', typeof propertyName === 'string');

  return object[propertyName];
});
